import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { iconButton } from './scss/Icons.module.scss';

const IconButton = ({ icon: Icon, className, ...buttonProps }) => (
  <button
    type="button"
    name="iconButton"
    aria-label="a button wrapping an icon"
    className={classNames(iconButton, className)}
    {...buttonProps}
  >
    <Icon />
  </button>
);

IconButton.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.func.isRequired,
};

IconButton.defaultProps = {
  className: '',
};

export default IconButton;
